import { TranslocoService } from "@jsverse/transloco";
import { map } from "rxjs";
import { GenericListField } from "@app/shared/models/GenericList/GenericListField";

/**
 * DashboardWidgetMapping's prettyName/description/dropdown Name values are "dashboard.widgetCatalog.*"
 * keys (the shared generic-field-editor has no transloco pipe of its own). Resolves them in place.
 */
export function translateWidgetCatalogField(transloco: TranslocoService, field: GenericListField) {
    if (field.prettyName?.startsWith("dashboard.")) {
        field.prettyName = transloco.translate(field.prettyName);
    }
    if (field.description?.startsWith("dashboard.")) {
        field.description = transloco.translate(field.description);
    }

    const translateNames = (items: { Name?: string }[]) => {
        items?.forEach((item) => {
            if (item?.Name?.startsWith("dashboard.")) {
                item.Name = transloco.translate(item.Name);
            }
        });
        return items;
    };

    if (field.getDataMethod) {
        const original = field.getDataMethod.bind(field);
        field.getDataMethod = () => original().pipe(map(translateNames));
    }

    if (field.getDataMethodByRow) {
        const original = field.getDataMethodByRow.bind(field);
        field.getDataMethodByRow = (row, ds) => original(row, ds).pipe(map(translateNames));
    }
}
